import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { useCancelRemittance } from "@saleor/remittanceRunner/mutations";
import { cancelRemittanceStyles } from "@saleor/remittanceRunner/styles/cancelRemittanceStyles";
import React, { FC } from "react";

import { remittanceRunnerToRemitPath } from "../../url";

export interface RemittanceRunnerCancelModalProps {
  remittanceID: string;
  remittanceNo: string;
  displayDialog: boolean;
  onClose: () => void;
}

const RemittanceRunnerCancelModal: FC<RemittanceRunnerCancelModalProps> = props => {
  const { remittanceID, remittanceNo, displayDialog, onClose } = props;

  const classes = cancelRemittanceStyles({});
  const navigate = useNavigator();
  const notify = useNotifier();

  const [
    saveCancelRemittanceId,
    saveCancelRemittanceIdOpts
  ] = useCancelRemittance({
    onCompleted: data => {
      if (data?.remittanceCancel?.errors?.length === 0) {
        navigate(remittanceRunnerToRemitPath);
      } else if (data?.remittanceCancel?.errors?.length > 0) {
        data.remittanceCancel.errors.forEach(error => {
          notify({
            status: "error",
            text: error.message
          });
        });
      }
    }
  });

  const handleSave = () => {
    saveCancelRemittanceId({
      variables: {
        id: remittanceID
      }
    });
  };

  return (
    <Dialog
      open={displayDialog}
      maxWidth="xs"
      aria-labelledby="cancel-remittance-dialog-title"
      aria-describedby="cancel-remittance-dialog"
    >
      <DialogContent>
        <CloseIcon className={classes.btnCloseIcon} onClick={onClose} />
        <DialogContentText id="cancel-remittance-dialog">
          <div className={classes.divFlexCentered}>
            <Typography className={classes.templateDialogTitle} variant="h5">
              Cancel Remittance
            </Typography>
          </div>

          <div className={classes.centerContent}>
            {"Are you sure you want to cancel"}
          </div>
          <div className={classes.midContent}>{remittanceNo}</div>
          <div className={classes.centerContent}>
            {"You cannot undo this process"}
          </div>

          <div className={classes.buttonActionCenter}>
            <Button
              color="primary"
              variant="outlined"
              className={classes.displayFlexMarginRight20}
              onClick={onClose}
            >
              NO
            </Button>
            <Button
              color="inherit"
              variant="contained"
              className={classes.btnRemit}
              onClick={handleSave}
              disabled={saveCancelRemittanceIdOpts.loading}
            >
              <Typography className={classes.textWhite}>YES</Typography>
            </Button>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default RemittanceRunnerCancelModal;
